// Action Types
export const FETCH_COMP_COMPARE_REQUEST = "FETCH_COMP_COMPARE_REQUEST";
export const FETCH_COMP_COMPARE_SUCCESS = "FETCH_COMP_COMPARE_SUCCESS";
export const FETCH_COMP_COMPARE_FAILURE = "FETCH_COMP_COMPARE_FAILURE";
export const FETCH_COMPETITOR_REQUEST = "FETCH_COMPETITOR_REQUEST"
export const FETCH_COMPETITOR_SUCCESS = "FETCH_COMPETITOR_SUCCESS"
export const FETCH_COMPETITOR_FAILURE = "FETCH_COMPETITOR_FAILURE"

// Action Creators
export const fetchCompCompareRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_COMP_COMPARE_REQUEST,
      payload: params,
    });
  };
};
export const fetchCompCompareSuccess = (data) => ({
  type: FETCH_COMP_COMPARE_SUCCESS,
  payload: data,
});
export const fetchCompCompareFailure = (error) => ({
  type: FETCH_COMP_COMPARE_FAILURE,
  payload: error,
});


export const fetchCompetitorRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_COMPETITOR_REQUEST,
      payload: params,
    });
  };
};
export const fetchCompetitorSuccess = (data) => ({
  type: FETCH_COMPETITOR_SUCCESS,
  payload: data,
});
export const fetchCompetitorFailure = (error) => ({
  type: FETCH_COMPETITOR_FAILURE,
  payload: error,
});
